import React, { createContext } from 'react'

const AuthContext = React.createContext({auth:{}, userInfoFromDB:{}, fetchUserFromDB: () => {}});

export const AuthProvider = AuthContext.Provider;
export const AuthConsumer = AuthContext.Consumer;

export default AuthContext;